import SingleRevision from './SingleRevision';

export default SingleRevision;
